import * as React from 'react';
import './ReturnsRmaRowMobile.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import isNumber from 'src/utils/isNumber';
import hasComma from 'src/utils/hasComma';
import { IReturnDetail } from 'src/services/returns/typings';
import { RMA_SUBMIT } from 'src/pages/ReturnsView/ReturnsView';
import IconMessage from 'src/components/common/IconMessage';

interface IReturnsRmaRowMobileProps {
  rmaItem: IReturnDetail;
  rmaData: IReturnDetail[];
  rmaItemFixed: IReturnDetail;
  action: string;
  handleChangeRmaData: (id: number) => void;
  handleChangeRmaDataInput: (value: IReturnDetail[]) => void;
  t?: any;
}

const ReturnsRmaRowMobile: React.FC<IReturnsRmaRowMobileProps> = props => {
  const {
    rmaItem,
    action,
    handleChangeRmaData,
    rmaItemFixed,
    rmaData,
    handleChangeRmaDataInput,
    t
  } = props;

  const [returnQty, setReturnQty] = React.useState<string>(
    String(rmaItem.returnQuantity)
  );
  const [reason, setReturnReason] = React.useState<string>(rmaItem.reason);

  React.useEffect(() => {
    const newRmaData = rmaData.map(rmaD => {
      if (rmaD.id === rmaItem.id) {
        return {
          ...rmaD,
          reason,
          returnQuantity: Number(returnQty)
        };
      } else {
        return rmaD;
      }
    });

    handleChangeRmaDataInput(newRmaData);
  }, [returnQty, reason]);

  const handleChangeReturnQty = (e: any) => {
    const qty = e.target.value;

    if (
      isNumber(qty) &&
      qty <= rmaItemFixed.returnQuantity + rmaItem.quantity
    ) {
      setReturnQty(qty);
    }
  };

  const handleChangeReason = (e: any) => {
    if (!hasComma(e.target.value)) {
      setReturnReason(e.target.value);
    }
  };

  return (
    <div className="rp-returns-rma-row-mobile">
      <div className="container-fluid">
        <div className="row rp-returns-rma-row-mobile-part-container">
          <div className="col-12">
            <div className="rp-returns-rma-row-mobile-part">
              <p className="rp-returns-rma-row-mobile-part-title">
                {rmaItem.partNumber}
              </p>
              <i
                onClick={() => handleChangeRmaData(rmaItem.id)}
                className="rpds-remove-circle rp-returns-rma-row-mobile-part-icon"
              />
            </div>
          </div>
        </div>
        <div className="row rp-returns-rma-row-mobile-content">
          <div className="col-12">
            <div className="row">
              <div className="col-3">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.invoiceNo')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.invoiceDate')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.price')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.mobile.rFee')}
                </p>
              </div>
            </div>
            <div className="row rp-returns-rma-row-mobile-content-data">
              <div className="col-3">
                <p>{rmaItem.invoiceNumber}</p>
              </div>
              <div className="col-3">
                <p>{rmaItem.invoiceDate}</p>
              </div>
              <div className="col-3">
                <p>{localeFormatingInstance.formatCurrency(rmaItem.price)}</p>
                {rmaItem.hasCoreIncluded && (
                  <IconMessage
                    icon={'rpds-error'}
                    message={'This price includes a Core Charge'}
                  />
                )}
              </div>
              <div className="col-3">
                <p>{rmaItem.restockingFee}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.returnQty')}
                </p>
              </div>
              <div className="col-8">
                <p className="rp-returns-rma-row-mobile-content-header">
                  {t('myReturns.reasonReference')}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                {action === RMA_SUBMIT ? (
                  <p>{rmaItem.returnQuantity}</p>
                ) : (
                  <>
                    <input
                      type="text"
                      value={returnQty}
                      onChange={handleChangeReturnQty}
                      className="rp-returns-rma-row-mobile-content-input qty"
                    />
                    / {rmaItemFixed.returnQuantity + rmaItem.quantity}
                  </>
                )}
              </div>
              <div className="col-8">
                {action === RMA_SUBMIT ? (
                  <p>{rmaItem.reason}</p>
                ) : (
                  <input
                    type="text"
                    value={reason}
                    onChange={handleChangeReason}
                    className="rp-returns-rma-row-mobile-content-input reason"
                    maxLength={60}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {!rmaItem.isValid && (
          <div className="row">
            <div className="col-12 rp-returns-rma-row-mobile-longer-available">
              <i className="rpds-error" />
              <p className="break-word-custom">
                {rmaItem.noOfDays
                  ? t('myReturns.rmaNoItemDisclaimerTxt', {
                      noOfDays: rmaItem.noOfDays
                    })
                  : t('myReturns.rmaNoItemDisclaimerTxtnodays')}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnsRmaRowMobile;
